import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-overview-generic-v2',
    templateUrl: './overview-generic-v2.component.html',
    styleUrls: ['./overview-generic-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OverviewGenericV2Component implements OnInit {
  @Input() generalDetails;
  @Input() generalData;
  customerName;
  constructor() { }

  ngOnInit() {
    this.customerName = localStorage.getItem('customerName');
  }

}
